/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dní na rozmyšlenou`
};

const da_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dages returret`
};

const de_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 Tage Rückgaberecht`
};

const en_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 days to change your mind`
};

const es_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 días para cambiar de opinión`
};

const fr_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 jours pour changer d'avis`
};

const hu_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 nap meggondolási idő`
};

const it_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 giorni per cambiare idea`
};

const nl_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dagen bedenktijd`
};

const pl_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dni na zwrot`
};

const pt_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dias para mudar de ideia`
};

const sv_reinsurances_return_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `14 dagar öppet köp`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_return_subtext = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_return_subtext(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_return_subtext", locale)
	if (locale === "cs") return cs_reinsurances_return_subtext(inputs)
	if (locale === "da") return da_reinsurances_return_subtext(inputs)
	if (locale === "de") return de_reinsurances_return_subtext(inputs)
	if (locale === "en") return en_reinsurances_return_subtext(inputs)
	if (locale === "es") return es_reinsurances_return_subtext(inputs)
	if (locale === "fr") return fr_reinsurances_return_subtext(inputs)
	if (locale === "hu") return hu_reinsurances_return_subtext(inputs)
	if (locale === "it") return it_reinsurances_return_subtext(inputs)
	if (locale === "nl") return nl_reinsurances_return_subtext(inputs)
	if (locale === "pl") return pl_reinsurances_return_subtext(inputs)
	if (locale === "pt") return pt_reinsurances_return_subtext(inputs)
	return sv_reinsurances_return_subtext(inputs)
};
export { reinsurances_return_subtext as "reinsurances.return_subtext" }